<template>
    <div class="nav-div">
        <nav>
            <a class="navbar-brand" href="">小亞洲</a>
            <ul class="navbar-nav">
                <li><a href="#menu" @click="this.scrollDown">Menu</a></li>
                <li><a href="#over-ons" @click="this.scrollDown">Over ons</a></li>
                <li><a href="#bezorgen" @click="this.scrollDown">Bezorgen</a></li>
            </ul>
            <img class="burger" src="@/assets/images/burger.png" @click='toggle()'>
        </nav>
        <div id="mySidenav" class="sidenav" v-if="isOpen">
            <a href="javascript:void(0)" class="closebtn" @click='toggle()'>&times;</a>
            <a href="#menu" @click='toggle()'>Menu</a>
            <a href="#over-ons" @click='toggle()'>Over Ons</a>
            <a href="#bezorgen" @click='toggle()'>Bezorgen</a>
            <a href="tel:010 42262-63">Reserveren</a>
            <h2>Little Asia</h2>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            isOpen: false
        }
    },
    methods:{
        toggle: function() {
            this.isOpen = !this.isOpen
        },
        scrollDown: function(e) {
            // Prevent usual link behaviour
            e.preventDefault()
            // Target from navigation exp #something
            let navigationTarget = e.target.getAttribute("href")
            // Find the target element
            let elementTarget = document.querySelector(navigationTarget)
            // Scroll to element
            elementTarget.scrollIntoView(true)
            window.scrollBy(0, -70);
        }
    }
};
</script>

<style lang="scss" scoped>
    nav {
        position: fixed;
        width: 100%;
        top:0;
        display: flex;
        background: linear-gradient(#3e3838 95%, transparent);
        align-items: center;
        padding: 1rem .5rem 1.3rem;
        z-index: 20;
        a {
            text-decoration: none;
            background-color: transparent;
            font-weight: bold;
        }
        .navbar-brand {
            display: inline-block;
            padding-top: .3125rem;
            padding-bottom: .3125rem;
            margin-left: 1rem;
            font-size: 2rem;
            line-height: inherit;
            white-space: nowrap;
            color: #B71C1C;
        }
        .navbar-nav {
            // float: right;
            display: flex;
            padding-left: 0;
            margin-top: 0;  
            margin-bottom: 0;
            margin-right: 1rem;
            list-style: none;
            margin-left: auto;
            li {
                a {
                    position: relative;
                    color: white;
                    display: block;
                    margin: .5rem 1rem;
                    &:hover, &:focus{
                        color: lightgray;
                    }
                    &:before {
                        content: "";
                        position: absolute;
                        width: 0;
                        height: 2px;
                        bottom: -5px;
                        left: 0;
                        background-color: #B71C1C;
                        -webkit-transition: width 0.3s ease-in-out 0s;
                        transition: width 0.3s ease-in-out 0s;
                    }
                    &:hover:before, &:focus:before{
                        width:100%;
                    }
                }
            }
        }
        .burger{
            display: none;
        }
    }
/* On screens that are 600px or less */
@media screen and (max-width: 600px) {
    nav {
        width: 100%;
        overflow: hidden;
        .navbar-nav{
            display: none;
        }
        .burger{
            display: flex;
            width: 40px;
            float: right;
            margin-right: 2rem;
            margin-left: auto;
        }
    }

        .sidenav {
        height: 100vh;
        width: 100vw;
        position: fixed;
        z-index: 20;
        top: 0;
        left: 0;
        background-color: rgb(63, 52, 52);
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 60px;
        text-align: center;
            h2{
                color: #B71C1C;
                margin-top: 30vw;
            }
            a{
                padding: 8px 0px 8px 0px;
                text-decoration: none;
                font-size: 11vw;
                color: #e93a3a;
                display: block;
                transition: 0.3s;
            }
            .closebtn {
                position: absolute;
                top: 0;
                right: 25px;
                font-size: 15vw;
                margin-left: 50px;
            }
        }
}
</style>
